import { useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FeaturedInventory from './components/FeaturedInventory';
import WorkTrucksSection from './components/WorkTrucksSection';
import AboutSection from './components/AboutSection';
import FinancingOptions from './components/FinancingOptions';
import NationwideShipping from './components/NationwideShipping';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

export default function HomePage() {
  useEffect(() => {
    const baseUrl = import.meta.env.VITE_SITE_URL || 'https://paramountautosusa.com';
    
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebSite",
          "@id": `${baseUrl}/#website`,
          "url": baseUrl,
          "name": "Paramount Motors",
          "description": "Premium pre-owned luxury and exotic vehicles in Miami, FL. Specializing in BMW, Mercedes-Benz, and high-performance cars with nationwide shipping.",
          "publisher": {
            "@id": `${baseUrl}/#organization`
          }
        },
        {
          "@type": "AutoDealer",
          "@id": `${baseUrl}/#organization`,
          "name": "Paramount Motors",
          "url": baseUrl,
          "logo": "https://static.readdy.ai/image/41574e0492e980fd88e2c6f8d59234d9/ff8f99c2c3d017ecd9846c9b47aca342.png",
          "image": "https://static.readdy.ai/image/41574e0492e980fd88e2c6f8d59234d9/ff8f99c2c3d017ecd9846c9b47aca342.png",
          "description": "Paramount Motors is a premier auto dealership in Miami, Florida, specializing in luxury and exotic pre-owned vehicles. We offer nationwide shipping, flexible financing, and a curated selection of high-performance cars.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Miami",
            "addressLocality": "Miami",
            "addressRegion": "FL",
            "addressCountry": "US"
          },
          "telephone": "+1-305-000-0000",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "09:00",
              "closes": "18:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Saturday",
              "opens": "10:00",
              "closes": "16:00"
            }
          ],
          "priceRange": "$$$$",
          "paymentAccepted": "Cash, Credit Card, Financing"
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0d0d0d]">
      <link rel="canonical" href="https://paramountautosusa.com/" />
      <Navbar />
      <HeroSection />
      <FeaturedInventory />
      <WorkTrucksSection />
      <AboutSection />
      <FinancingOptions />
      <NationwideShipping />
      <Testimonials />
      <Footer />
    </div>
  );
}